import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { map, skipWhile, switchMap, take } from 'rxjs/operators';

import { APP_STATES } from '../enums/app.enum';
import { getAppStatus } from '../selectors/init.selectors';
import { getUserHasNatureReportingAccess } from '../selectors/organisation.selectors';

@Injectable({ providedIn: 'root' })
export class NatureReportingGuard {
  public router = inject(Router);
  private store = inject(Store);

  canActivate() {
    return this.store.select(getAppStatus).pipe(
      skipWhile((status) => status === APP_STATES.IDLE),
      take(1),
      switchMap(() => this.store.select(getUserHasNatureReportingAccess)),
      map((enabled) => {
        if (!enabled) {
          this.router.navigate(['/']);
        }
        return true;
      })
    );
  }
}
